module.exports = __webpack_public_path__ + "static/media/card_orcamento_optico.05614426.jpg";